import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import List from "./homeeventcouponlist";
import { getActionUser } from "../../action/actionlogin";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
const { width, height } = Dimensions.get("window");

export default function HomeEventCoupon({ navigation }) {
  const [page, setPage] = useState(0);
  const [isSuperAdmin, setIsSuperAdmin] = useState(true);
  const token = useRecoilValue(tokenState);
  const [eventId, setEventId] = useState(null);

  async function getAdminInformation() {
    const results = await getActionUser(token)
    if (results.status == 200) {
      setIsSuperAdmin(results.data.data.event_id === null);
      setPage(results.data.data.event_id === null ? 0 : 1);
      setEventId(results.data.data.event_id);

      return
    }

    navigation.navigate("Login");
  }

  useEffect(() => {
    getAdminInformation();
  }, []);

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin />
        <Text style={styles.textfree}>EVENTS</Text>
        <View style={styles.viewfree}>
          <View style={[styles.viewfree, { width: "50%" }]}>

            <TouchableOpacity
              disabled
              onPress={() => setPage(1)}
              style={[
                styles.touch,
                { backgroundColor: page == 1 ? "#FCC81D" : "#fff" },
              ]}
            >
              <Text style={styles.textadd}>อีเวนท์</Text>
            </TouchableOpacity>

          </View>
          {(isSuperAdmin) && (
            <TouchableOpacity
              onPress={() => navigation.navigate("CreateCoupon")}
              style={[styles.touch, { backgroundColor: "#fff", width: "10%" }]}
            >
              <Text style={styles.textadd}>ADD</Text>
            </TouchableOpacity>
          )}
        </View>
        {<List navigation={navigation} eventId={eventId} isSuperAdmin={isSuperAdmin} />}
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: "85%",
    height: height,
    paddingHorizontal: "1%",
  },
  viewfree: {
    justifyContent: "space-between",
    width: "99%",
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
  },
  touch: {
    width: "20%",
    height: 40,
    justifyContent: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#8898AA",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
});
